import {call, put, select} from 'redux-saga/effects';
import actions from "../actions";
import {get} from "../../../shared/ApiService";
import {message} from "antd";
import {getServerUrl} from "../../Transaction/helpers/getServerUrl";

export function* onRequestDataForItemModal(action, context) {
    try {
        const state = yield select();
        const {
            originType,
            selections,
            lists,
        } = state.TransactionTransfer;

        const selectedIds = selections.map(s => s.transactionId);
        const list = [...lists.itemModal];
        const { originalQuantities } = lists;

        const toReadIds = selectedIds.filter(id => {
            const existed = list.find(d => d.id === id);
            return !existed;
        });

        if (toReadIds.length > 0) {
            yield put({
                type: actions.TXN_TRANSFER_GET_ITEM_MODAL_DATA_REQUEST,
            });

            // Stage 1: Filter out data
            for (const id of toReadIds) {
                const res = yield call(get, `${getServerUrl(originType)}/${id}`, null, context);
                const data = yield res.data.transaction;

                // Process form items
                data.form_items = data.form_items
                    // Remove subtotal & subtitle
                    .filter(item => item.type !== 'subtotal' && item.type !== 'subtitle')

                    // Add-in original_quantity & transferred_to_quantity (from originalQuantities)
                    .map(item => {
                        const originalQtyItem = originalQuantities.find(qty => (
                            qty.transactionId === id && qty.transactionItemId === item.id
                        ));

                        if (originalQtyItem) {
                            return {
                                ...item,
                                original_quantity: originalQtyItem.quantity,
                                transferred_to_quantity: originalQtyItem.transferredToQuantity,
                            };
                        }
                        return item;
                    })

                    // Remove item with zero balance
                    .filter(item => (
                        item.balance_quantity + (item.original_quantity || 0)
                    ));

                // Append to list
                list.push(data);
            }
        }

        yield put({
            type: actions.TXN_TRANSFER_GET_ITEM_MODAL_DATA_SUCCESS,
            list,
        });
    }
    catch (error) {
        yield put({
            type: actions.TXN_TRANSFER_GET_ITEM_MODAL_DATA_ERROR,
            error,
        });
        yield message.error(error.message);
    }
}
